import React, { useEffect, useRef, useState } from 'react'
import ModalWrapper from '../ModalWrapper'
import { ReactComponent as CloseIcon } from '../../../assets/icons/cross.svg'
import { ReactComponent as ArrowIcon } from '../../../assets/icons/prev-arrow.svg'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import 'swiper/css'
import s from './index.module.scss'
import classNames from 'classnames'
import Loader from '../Loader'
import { exportHandler, getFile } from '../../../helpers'

const IMG_FORMATS = ['jpg', 'jpeg', 'png', 'HEIC']

const FileLoader = ({ path }: { path: string }) => {
	const extension = path.split('.').splice(-1)[0]

	const [src, setSrc] = useState('')
	const [fileName] = useState(() => {
		let fileName = path

		if (path.includes('ttn')) fileName = 'ТТН.pdf'
		if (path.includes('excise-invoice')) fileName = 'Акцизна накладна.pdf'

		return fileName
	})

	useEffect(() => {
		if (!path) return

		if (path.indexOf('.') === -1) {
			exportHandler(path, fileName, 'pdf', true, true).then((res: any) => setSrc(res))
		} else {
			getFile(path).then((res) => setSrc(res))
		}
	}, [path])

	if (!src) {
		return (
			<div className={s.fileWrapper}>
				<Loader />
			</div>
		)
	}

	if (IMG_FORMATS.includes(extension)) {
		return <img src={src} alt="Picture" />
	}

	return (
		<div className={s.fileWrapper}>
			<a href={src} download={fileName} className={s.downloadLink}>
				Завантажити
			</a>
		</div>
	)
}

const SliderModal = ({ files }: { files: string[] }) => {
	const navigationPrevRef = useRef(null)
	const navigationNextRef = useRef(null)

	const [isAnimate, setIsAnimate] = useState<boolean>(false)
	const [modalIsVisible, setModalIsVisible] = useState<boolean>(false)
	const [slides, setSlides] = useState<number[]>([0])

	const onClose = () => {
		setIsAnimate(true)
		setTimeout(() => {
			setModalIsVisible(false)
		}, 300)
	}

	const onShow = () => {
		setIsAnimate(false)
		setModalIsVisible(true)
	}

	useEffect(() => {
		const listener = (event: KeyboardEvent) => {
			if (event.code === 'Escape') {
				onClose()
			}
		}

		document.addEventListener('keydown', listener)
		return () => document.removeEventListener('keydown', listener)
	}, [])

	if (!files.length) return <>-</>

	return (
		<div onClick={(ev: React.MouseEvent<HTMLElement>) => ev.stopPropagation()}>
			<span className={s.text} onClick={onShow}>
				Переглянути
			</span>

			{modalIsVisible && (
				<ModalWrapper closeHandler={onClose} isAnimate={isAnimate}>
					<div
						className={classNames(s.wrapper, {
							[s.animate]: isAnimate,
						})}
					>
						<CloseIcon className={s.closeIcon} onClick={onClose} />

						{files.length > 1 && (
							<>
								<button ref={navigationPrevRef} className={classNames(s.btn, s.btnPrev)}>
									<ArrowIcon />
								</button>
								<button ref={navigationNextRef} className={classNames(s.btn, s.btnNext)}>
									<ArrowIcon />
								</button>
							</>
						)}

						<Swiper
							slidesPerView={1}
							modules={[Navigation]}
							navigation={{
								prevEl: navigationPrevRef.current,
								nextEl: navigationNextRef.current,
							}}
							onBeforeInit={(swiper: any) => {
								swiper.params.navigation.prevEl = navigationPrevRef.current
								swiper.params.navigation.nextEl = navigationNextRef.current
							}}
							onSlideChange={({ activeIndex }) => setSlides((prev) => [...prev, activeIndex])}
						>
							{files.map((i, index) => (
								<SwiperSlide key={i} className={s.slide}>
									{Array.from(new Set(slides)).includes(index) && <FileLoader path={i} />}
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</ModalWrapper>
			)}
		</div>
	)
}

export default SliderModal
